import { render, staticRenderFns } from "./asset-history-report.vue?vue&type=template&id=3ca90cd8&scoped=true&"
import script from "./js/asset-history-report.js?vue&type=script&lang=js&"
export * from "./js/asset-history-report.js?vue&type=script&lang=js&"
import style0 from "./asset-history-report.vue?vue&type=style&index=0&id=3ca90cd8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ca90cd8",
  null
  
)

export default component.exports